import { LoginCredentials, RegisterCredentials, User } from '../types/auth.types';
import axiosInstance, { publicAxiosInstance } from '../../utils/axios';

export const authService = {
  async login(credentials: LoginCredentials): Promise<{ access_token: string }> {
    const response = await publicAxiosInstance.post('/api/v1/auth/login', credentials);
    return response.data;
  },

  async register(credentials: RegisterCredentials): Promise<{ access_token: string }> {
    const { username, password } = credentials;
    const response = await publicAxiosInstance.post('/api/v1/auth/register', { username, password });
    return response.data;
  },

  async validateToken(): Promise<User> {
    const response = await axiosInstance.get('/api/v1/users/me');
    return response.data;
  },

  setToken(token: string) {
    localStorage.setItem('token', token);
    // Token will be automatically added by axios interceptor
  },

  clearToken() {
    localStorage.removeItem('token');
    // Token will be automatically removed when cleared from localStorage
  },

  getToken() {
    return localStorage.getItem('token');
  }
};
